import ConfirmAndDelete from "components/molecules/ConfirmAndDelete";
import React from "react";
import { useRecoilValue } from "recoil";
import { genericDeleteParams } from "./genericDeleteState";

const GenericDeleteContainer: React.FC = () => {
  const deleteParams = useRecoilValue(genericDeleteParams);

  return (
    <ConfirmAndDelete
      title={deleteParams.modalTitle ?? ""}
      message={deleteParams?.modalMessage}
      open={!!deleteParams?.id && !!deleteParams?.entity}
    />
  );
};

export default GenericDeleteContainer;
